module.exports = __webpack_public_path__ + "static/media/portal_logo.57e71cf8.svg";